module.exports = __webpack_public_path__ + "img/alitas.54b4dd55.jpg";